export default "__VITE_ASSET__xtdzdUA0__"